import * as React from 'react';

// styles for .greenBody global
import './GreenPageBody.module.css';

const bodyClass = 'greenBody';

/**
 *  Used for a few purposes on pages with a green background 
 *  1) Prevent leakage of white baackground on scroll-to-top/bottom
 *  2) Provide a green background + styling class for the PageFooter component 
 */
const GreenPageBody = () => {
  React.useEffect(() => {
    document.body.classList.add(bodyClass);     
    // remove on unmount
    return () => { document.body.classList.remove(bodyClass); };  
  });  
  return null;
};

export default GreenPageBody;